import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import AttachmentsTr from '../table-componets/AttachmentsTr.js'
import GeneralTr from '../table-componets/GeneralTr.js'
import MarkdownTr from '../table-componets/MarkdownTr.js'
import SubmittedByTr from '../table-componets/SubmittedByTr.js'
import DateTr from '../table-componets/DateTr.js'
import History from "./History";

class ShiftReport extends React.Component {
  state = {
    openStatus: this.props.shift_report.open_status
  }

  deleteShiftReport = () => {
    axios.delete('/shift_reports/' + this.props.shift_report.id)
    .then(function (response) {
      toastr.error('Shift Report deleted')
      setTimeout(function() { window.location.href = '/shift_reports'; }.bind(this), 300)
    })
    .catch(function (error) {
      toastr.error('An error occured, please try again.')
      console.log(error)
    })
  }

  setOpenStatus = (status) => {
    var that = this

    axios.put('/shift_reports/' + this.props.shift_report.id + '.json', {
      shift_report: {
        open_status: status
      }
    })
    .then(function (response) {
      toastr.info('Shift Report status updated')
      that.setState({ openStatus: status })
    })
    .catch(function (error) {
      toastr.error('An error occured, please try again.')
      console.log(error)
    })
  }

  renderStatusButton = () => {
    var that = this

    if (this.props.currentUser.admin && this.state.openStatus) {
      return (
        <span>
          <a 
              className='btn btn-indigo btn-raised btn-long margin-right-five hidden-xs'
              onClick={function(){that.setOpenStatus(false)}}
              role='button'
              tabIndex='0'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  that.setOpenStatus(false)
                }
              }}
             >
            CLOSE
          </a>
          <a 
              className='btn btn-indigo btn-raised btn-long margin-right-five visible-xs pull-right'
              onClick={function(){that.setOpenStatus(false)}}
              role='button'
              tabIndex='0'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  that.setOpenStatus(false)
                }
              }}
             >
            CLOSE
          </a>
        </span>
      )
    }
    else if (this.props.currentUser.admin && !this.state.openStatus) {
      return (
        <span>
          <a 
              className='btn btn-indigo btn-raised btn-long margin-right-five hidden-xs'
              onClick={function(){that.setOpenStatus(true)}}
              role='button'
              tabIndex='0'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  that.setOpenStatus(true)
                }
              }}
             >
            OPEN
          </a>
          <a 
              className='btn btn-indigo btn-raised btn-long margin-right-five visible-xs pull-right'
              onClick={function(){that.setOpenStatus(true)}}
              role='button'
              tabIndex='0'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  that.setOpenStatus(true)
                }
              }}
             >
            OPEN
          </a>
        </span>
      )
    }
  }

  render() {
    var that = this;

    return(
      <div>
        <h1>Shift Report</h1>
        {this.renderStatusButton()}
        <br className='visible-xs'/>
        <br className='visible-xs'/>

        <div className='pull-right'>
          {(that.props.currentUser.admin || that.props.currentUser.id == that.props.user.id) &&
            <a href={'/shift_reports/' + that.props.shift_report.id + '/edit'}
               className='btn btn-pink btn-raised btn-long margin-right-five'>
              EDIT
            </a>
          }

          {(that.props.currentUser.admin || that.props.currentUser.id == that.props.user.id) &&
            <a
              key="pdf"
              href={`/shift_reports/${that.props.shift_report.id}.pdf`}
              target="_blank"
              className="btn btn-indigo btn-raised btn-long margin-right-five"
            >
              PDF
            </a>
          }

          {that.props.currentUser.admin ? <History history={this.props.history}/> : null}

          {that.props.currentUser.admin &&
            <a
              className='btn btn-default btn-raised btn-long'
              onClick={function(){that.deleteShiftReport()}}
              role='button'
              tabIndex='0'
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  that.deleteShiftReport();
                }
              }}
          >
            DELETE
          </a>
          
          }
        </div>

        {(that.props.currentUser.admin || that.props.currentUser.id == that.props.user.id) &&
          <span>
            <br />
            <br />
          </span>
        }

        <br />
        <div className='shadowDepth1'>
          <table className="table table-bordered table-white">
            <tbody>
              <GeneralTr
                fieldName={'Location'}
                fieldValue={that.props.location.name} />
              <SubmittedByTr user={that.props.user} />
              <DateTr
                fieldName={'Submitted At'}
                fieldValue={that.props.shift_report.created_at}
                fieldFormat={'M/D/YYYY @ h:mma'} />
              <MarkdownTr
                fieldName={'Content'}
                fieldValue={that.props.shift_report.content} />
              <GeneralTr
                fieldName={'Status'}
                fieldValue={that.state.openStatus ? 'Open' : 'Closed'} />
              <GeneralTr
                fieldName={'Report Filed'}
                fieldValue={that.props.shift_report.report_filed_word} />
              <AttachmentsTr
                fieldName={'Attachments'}
                fieldValue={that.props.attachments}
              />
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

ShiftReport.propTypes = {
  shift_report: PropTypes.object,
  attachments: PropTypes.array,
  location: PropTypes.object,
  user: PropTypes.object,
  currentUser: PropTypes.object,
  history: PropTypes.array
};

export default ShiftReport
